// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  performanceReportsPlantStatusSubRoute,
  PLANT_STATUS_SUB_PATH
} from '@features/performance-reports'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {
  buildFeatureUrl,
  useSuiteHierarchyId,
  useUpmPlantFromHierarchyId
} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {useUpmHierarchyAreaNavigation} from '@widgets/area-dashboard'
import {Suspense} from 'react'
import {useNavigate, generatePath, RouteObject} from 'react-router'

import {optimizationSpecialistDashboardFeatureTranslations} from '../localization'
import {OptimizationSpecialistAreaDashboard, OptimizationSpecialistPlantDashboard} from '../pages'

const FEATURE_NAME = 'OptimizationSpecialistDashboard'

const SuiteOptimizationSpecialistDashboard = ({plantId}: {plantId: string}) => {
  const navigate = useNavigate()

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  return (
    <OptimizationSpecialistPlantDashboard
      plantId={plantId}
      onEquipmentClick={navigateToStoppageAnalysis}
      optimizationSpecialistPerformanceHref={PLANT_STATUS_SUB_PATH}
    />
  )
}

const SuiteOptimizationSpecialistAreaDashboard = () => {
  const hierarchyId = useSuiteHierarchyId()
  const navigation = useUpmHierarchyAreaNavigation({
    upmAreaId: hierarchyId ?? undefined,
    getNodeLink: (upmHierarchyId) => buildFeatureUrl(FEATURE_NAME, upmHierarchyId)
  })

  return (
    <OptimizationSpecialistAreaDashboard
      dashboardRoute={buildFeatureUrl(FEATURE_NAME)}
      navigation={navigation}
    />
  )
}

const SuiteOptimizationSpecialistNodeDashboard = () => {
  const plant = useUpmPlantFromHierarchyId()

  if (plant === undefined) {
    return null
  }

  return plant ? (
    <SuiteOptimizationSpecialistDashboard plantId={plant.plantId} />
  ) : (
    <SuiteOptimizationSpecialistAreaDashboard />
  )
}

const SuiteOptimizationSpecialistDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={optimizationSpecialistDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuiteOptimizationSpecialistNodeDashboard />
        </Suspense>
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const optimizationSpecialistDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteOptimizationSpecialistDashboardRouteWrapper />
    },
    performanceReportsPlantStatusSubRoute,
    stoppageAnalysisSubRoute
  ]
}
